import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from './components';
import { AppProviders } from './context';
import { BrowserRouter as Router } from 'react-router-dom';

import './i18n';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
    <AppProviders>
        <Router>
            <App />
        </Router>
    </AppProviders>, 
    document.getElementById('app')
);
